<template>
  <component
    :is="layoutComponent"
    v-bind="layoutProps">
    <template slot="field">
      <form-card :html="htmlData" />
    </template>
  </component>
</template>

<script>
  import { FieldMixin } from '../mixins';
  import FormCard from '../common/Card.vue';

  export default {
    name: 'FormCardField',
    components: {
      FormCard: FormCard,
    },

    mixins: [FieldMixin],

    props: {
      data: {},
    },

    computed: {
      /**
       * Get the input type.
       */
      htmlData() {
        return this.$t(this.field.html) || ''
      },
    },

    methods: {

    },
  }
</script>
